export default "__VITE_ASSET__qfVXINP6__"